/**
 * @generated SignedSource<<ce0eb7ce66b1914471dec120ca392a23>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView$data = {
  readonly isLinkEditable: boolean | null | undefined;
  readonly issue: {
    readonly id: string;
  } | null | undefined;
  readonly project: {
    readonly atlasProjectKey: string | null | undefined;
    readonly atlasProjectName: string | null | undefined;
    readonly hasPermission: boolean | null | undefined;
    readonly id: string;
    readonly isWorkspaceActive: boolean | null | undefined;
    readonly privateProject: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView";
};
export type atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView$key = {
  readonly " $data"?: atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isLinkEditable"
    },
    {
      "concreteType": "JiraTownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": (v0/*: any*/),
          "action": "THROW",
          "path": "project.id"
        },
        {
          "alias": "atlasProjectKey",
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "alias": "atlasProjectName",
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "privateProject"
        },
        {
          "kind": "ScalarField",
          "name": "hasPermission"
        },
        {
          "kind": "ScalarField",
          "name": "isWorkspaceActive"
        }
      ]
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": (v0/*: any*/),
          "action": "THROW",
          "path": "issue.id"
        }
      ]
    }
  ],
  "type": "JiraTownsquareProjectField"
};
})();

(node as any).hash = "87020946b61803dccd36df8793fbe401";

export default node;
